export enum AgingPeriodEnum {
  None,
  AllOpen,
  AllPastDue,
  DaysPastDue30,
  DaysPastDue60,
  DaysPastDue90,
  DaysPastDue120AndMore,
  NotYetDue
}
